export const graphqlGetBookingHomepage = `
  query GetBookingHomepage($language: LanguageCode) @inContext(language: $language) {
    metaobjects(type:"booking_homepage", first:1) {
      edges {
        node {
          fields {
            key
            value
            reference {
              ... on MediaImage {
                image {
                  url
                }
              }
              ... on Video {
                sources {
                  url
                  format
                  height
                  width
                }
              }
            }
          }
        }
      }
    }
  }`;

export const graphqlPlacesGetDefaultPanel = `{
  metaobjects(type: "search_bar", first: 1) {
    nodes {
      places: field(key: "villes") {
        value
      }
      centers: field(key: "spas") {
        references(first: 10) {
          nodes {
            ... on Metaobject {
              name: field(key: "nom_du_spa") {
                value
              }
              region: field(key: "region") {
                value
              }
              address: field(key: "adresse_postale_booking") {
                value
              }
            }
          }
        }
      }
    }
  }
}`;

export const graphqlSearchbarGetServicesAndSettings = `{
  highlights: metaobjects(type: "custom_booking_services_highlight", first: 10) {
    nodes {
      name: field(key: "name") {
        value
      }
      pictogram: field(key: "pictogram") {
        reference {
          ... on MediaImage {
            image {
              url
              altText
              width
              height
            }
          }
        }
      }
    }
  }
  otherServices: metaobjects(type: "custom_booking_services_subcategories", first: 10) {
    nodes {
      category: field(key:"services_categories") {
        value
      }
      fields {
        key
        value
      }
    }
  }
  settings: metaobjects(type: "search_bar", first: 10) {
    nodes {
      countries: field(key: "google_maps_country_restrictions") {
        value
      }
    }
  }
}`;

export const graphqlStepsGetCentersAndServicesVariants = `
query GetData($language: LanguageCode) @inContext(language: $language) {
  collectionByHandle(handle: "soins") {
    id
    description
    title
    products(first:100) {
      edges {
        node {
          id
          title
          description
          variants(first: 50) {
            edges {
              node {
                id
                title
                priceV2 {
                  amount
                  currencyCode
                }
                metafield(namespace: "custom", key: "id_pms") {
                  value
                }
              }
            }
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          featuredImage {
            url
            altText
          }
          centersList: metafield(namespace: "custom", key: "liste_de_spas") {
            value
            type
            references(first: 100) {
              edges {
                node {
                  ... on Metaobject {
                    id
                    handle
                    type
                    fields {
                      key
                      type
                      value
                      reference {
                        ... on MediaImage {
                          id
                          image {
                            url
                            altText
                          }
                        }
                        ... on OnlineStorePublishable {
                          onlineStoreUrl
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          badges: metafield(namespace: "custom", key: "badges") {
            value
            type
            references(first: 10) {
              edges {
                node {
                  ... on Metaobject {
                    id
                    handle
                    type
                  }
                }
              }
            }
          }
          soloDuo: metafield(namespace: "custom", key: "solo_duo") {
            value
            type
            references(first: 10) {
              edges {
                node {
                  ... on Metaobject {
                    id
                    handle
                    type
                    fields {
                      key
                      value
                    }
                  }
                }
              }
            }
          }
          durationServices: metafield(namespace: "custom", key: "temps_de_soin") {
            value
            type
            references(first: 10) {
              edges {
                node {
                  ... on Metaobject {
                    id
                    handle
                    type
                    fields {
                      key
                      type
                      value
                    }
                  }
                }
              }
            }
          }
          serviceFamily: metafield(namespace: "custom", key: "famille_de_soin_parcours_de_booking") {
            value
            type
            references(first: 10) {
              edges {
                node {
                  ... on Metaobject {
                    id
                    handle
                    type
                    fields {
                      key
                      value
                    }
                  }
                }
              }
            }
          }
          iconic: metafield(namespace: "custom", key: "soins_iconiques_booking") {
            value
            type
          }
          servicesSubcategories: metafield(namespace: "custom", key: "custom_booking_services_subcategories") {
            value
            type
            id
            reference {
              ... on Metaobject {
                id
                handle
                type
                fields {
                  key
                  value
                }
              }
            }
          }
          servicesHighlights: metafield(namespace: "custom", key: "custom_booking_services_highlight") {
            value
            type
            id
            reference {
              ... on Metaobject {
                id
                handle
                type
                fields {
                  key
                  value
                }
              }
            }
          }
        }
      }
    }
  }
  settings: metaobjects(type: "search_bar", first: 10) {
    nodes {
      radius: field(key: "rayon_de_recherche_geoloc") {
        value
      }
      centerLocatorImage: field(key: "no_spa_spa_locator_visual") {
        reference {
          ... on MediaImage {
            alt
            image {
              url
              width
              height
            }
          }
        }
      }
      centerLocatorLink: field(key: "no_spa_spa_locator_url") {
        value
      }
      productsImage: field(key: "no_spa_product_visual") {
        reference {
          ... on MediaImage {
            alt
            image {
              url
              width
              height
            }
          }
        }
      }
      productPageLink: field(key: "no_spa_product_page_url") {
        value
      }
    }
  }
}`;

export const graphqlGetBookingConfirmationData = `
  query getBookingConfirmationData($language: LanguageCode) @inContext(language: $language) {
    metaobjects(type:"booking_confirmation", first:1) {
      edges {
        node {
          type
          fields {
            key
            value
          }
        }
      }
    }
  }
`;

export const graphqlFormGetProductsAndCenters = `
  query GetCentersAndProducts($language: LanguageCode) @inContext(language: $language) {
    collectionByHandle(handle: "soins") {
      products(first:100) {
        edges {
          node {
            id
            title
            variants(first: 50) {
              edges {
                node {
                  id
                  title
                  priceV2 {
                    amount
                    currencyCode
                  }
                  selectedOptions {
                    name
                    value
                  }
                  metafield(namespace: "custom", key: "id_pms") {
                    value
                  }
                }
              }
            }
            centersList: metafield(namespace: "custom", key: "liste_de_spas") {
              references(first: 100) {
                edges {
                  node {
                    ... on Metaobject {
                      fields {
                        key
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`;

export function graphqlFormGetVariantService(id) {
  return `
  query getVariantService($language: LanguageCode) @inContext(language: $language) {
    products(first: 100, query: "id:${id}") {
      nodes {
        title
        id
        variants (first: 50) {
          edges {
            node {
              title
              selectedOptions {
                name
                value
              }
              id
              metafield (namespace: "custom", key: "id_pms") {
                value
              }
            }
          }
        }
      }
    }
  }`
};

export const graphqlGetTranslations = `
  query GetUITranslations($language: LanguageCode) @inContext(language: $language) {
    metaobjects(type: "booking_translation", first: 100) {
      edges {
        node {
          handle
          fields {
            key
            value
          }
        }
      }
    }
  }
`;
